<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="商场ID"
                        prop="marketid">
            <el-input placeholder="请输入商场id"
                      v-model="search.id"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店系统"
                        prop="custom">
            <el-input placeholder="请输入门店系统"
                      v-model="search.custom"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店名称"
                        prop="marketname">
            <el-input placeholder="请输入门店名称"
                      v-model="search.marketname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="地址"
                        prop="address">
            <el-input placeholder="请输入地址"
                      v-model="search.address"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="所属客户"
                        prop="customer">
            <el-input placeholder="请输入所属客户"
                      v-model="search.customer"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="城市等级"
                        prop="city_level">
            <el-select v-model="search.city_level"
                       placeholder="请选择城市等级"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.city_level"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卖场规模"
                        prop="market_size">
            <el-select v-model="search.market_size"
                       placeholder="请选择卖场规模"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.market_size"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否连锁"
                        prop="is_chain">
            <el-select v-model="search.is_chain"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.is_chain"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示"
                        prop="status">
            <el-select v-model="search.status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查理宝平台"
                        prop="isee">
            <el-select v-model="search.isee"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.isee"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店类型"
                        prop="markettype">
            <el-select v-model="search.markettype"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.markettype"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省份"
                        prop="provinceid">
            <el-select v-model="search.provinceid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetProvince"
                       @change="onChangeProvince"
                       clearable>
              <el-option
                v-for="item in provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市"
                        prop="cityid">
            <el-select v-model="search.cityid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetCities"
                       @change="onChangeCity"
                       clearable>
              <el-option
                v-for="item in cities"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区"
                        prop="areaid">
            <el-select v-model="search.areaid"
                       filterable
                       placeholder="请选择"
                       @visible-change="onGetAreaes"
                       clearable>
              <el-option
                v-for="item in areaes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="mini"
                       native-type="submit">搜索
            </el-button>
            <!--<el-button icon="sj-icon-export"-->
            <!--size="mini"-->
            <!--@click="onExportSearch()">导出-->
            <!--</el-button>-->
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-tooltip class="item"
                    effect="dark"
                    content="导出"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="sj-icon-export"
                     @click="onExport()"></el-button>
        </el-tooltip>

        <el-tooltip class="item"
                    effect="dark"
                    content="刷新"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh()"></el-button>
        </el-tooltip>
      </template>
      <div class="margin b15">
        <router-link :to="'/market/create'">
          <el-button type="primary"
                     size="mini"
          > 添加商户
          </el-button>
        </router-link>

        <el-button size="mini" type="primary"
                   @click="exportDialogVisible=true">按搜索结果导出
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="customer"
                         label="所属客户"></el-table-column>
        <el-table-column prop="custom"
                         label="门店系统"></el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"></el-table-column>
        <el-table-column prop="markettype"
                         label="门店类型">
          <template slot-scope="scope">
            <span v-for="item in options.markettype"
                  v-if="item.value === scope.row.markettype">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column label="省市区">
          <template slot-scope="scope">
            <span>{{scope.row.provincename}} - {{scope.row.cityname}} - {{scope.row.areaname}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="street"
                         label="街道地址">
          <template slot-scope="scope">
            {{scope.row.street}} - {{scope.row.street_number}}
          </template>
        </el-table-column>
        <el-table-column prop="address"
                         label="门店参考地址"></el-table-column>
        <el-table-column prop="city_level"
                         label="城市等级">
          <template slot-scope="scope">
            <span v-for="(item,index) in options.city_level"
                  :key="index"
                  v-if="scope.row.city_level === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="market_size"
                         label="卖场规模">
          <template slot-scope="scope">
            <span v-for="(item,index) in options.market_size"
                  :key="index"
                  v-if="scope.row.market_size === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_chain"
                         label="是否连锁">
          <template slot-scope="scope">
            <span v-for="item in options.is_chain"
                  v-if="item.value === scope.row.is_chain">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户数"
                         min-width="120">
          <template slot-scope="scope">
            <router-link :to="'/users/table?marketid='+scope.row.id">{{scope.row.userstatistic}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="taskstatistic"
                         label="未完成工单数"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
        >
          <template slot-scope="scope">
            <router-link :to="'/market/update/'+scope.row.id">
              <el-button type="text"
                         size="mini">修改
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       @click="onUpdateTask(scope.row.id)">批量更新任务
            </el-button>
            <el-button type="text"
                       size="mini"
                       @click="onDelete(scope.row.id)">删除
            </el-button>
            <router-link :to="'/market/log/'+scope.row.id">
              <el-button type="text"
                         size="mini">日志
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog title="导出数据确认"
               :visible.sync="exportDialogVisible"
               width="45%">
      <div style="font-size: large">共导出{{pagination.total}}条数据</div>
      <el-checkbox class="margin t20"
                   v-model="exportAsync">后台异步导出（建议1w条数据以上时勾选，勾选后请于门店上传列表确认导出数据）
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="exportMarket()"
                   :disabled="pagination.total === 0"
                   size="mini">导出门店数据</el-button>
        <el-button @click="exportDialogVisible = false"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import marketMixins from '../market.mixins'

export default {
  components: {},
  mixins: [table, marketMixins],
  data () {
    return {
      table: [],
      search: {
        id: null,
        custom: null,
        marketname: null,
        address: null,
        customer: null,
        city_level: null,
        market_size: null,
        is_chain: null,
        isee: null,
        markettype: null,
        provinceid: null,
        cityid: null,
        areaid: null,
        status: 1,
      },
      loading: false,
      provinces: [],
      cities: [],
      areaes: [],
      // 搜索字段申明
      searchFieldType: {
        id: Number,
        city_level: Number,
        market_size: Number,
        is_chain: Number,
        isee: Number,
        markettype: Number,
        status: Number,
      },
      exportDialogVisible: false,
      exportAsync: false,
    }
  },
  computed: Vuex.mapState({
    options: state => state.market.options,
  }),
  created () {
  },
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      // 存在id获取省市区列表信息
      if (params.provinceid) {
        this.onGetProvince()
      }
      if (params.cityid) {
        this.onGetCities(true)
      }
      if (params.areaid) {
        this.onGetAreaes(true)
      }
      return request.common('queryMarket', params)
    },
    exportMarket () {
      this.exportDialogVisible = false
      if (this.exportAsync) {
        this.onExportAsync(filter.copyJson(this.search))
      } else {
        this.onExport()
      }
    },
    onExport () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('exportMarket', params),
        requestParams: this.search,
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onExportAsync (detail) {
      detail.exportAsync = this.exportAsync
      return request.common('exportMarket', detail).then(() => {
        return this.$message.success('创建成功，请在 门店上传 菜单页面查看！')
      })
    },
    onUpdateTask (marketid) {
      this.$confirm('你确定要批量更新吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.loading('updateTaskByMarket', {id: marketid}).then((res) => {
          this.$confirm('批量任务创建成功，是否前往任务列表查看?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.$router.push({path: '/market/upload/table'})
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消批量更新',
        })
      })
    },
    onDelete (marketid) {
      this.$confirm('你确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('deleteMarket', {id: marketid}).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/market/pages/MarketTable.vue